import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["$divider", "$isHover", "$isActive", "$useBrowserDefaultFocusStyle", "$isUsingKeyboard", "$size", "component"];
import React from 'react';
import { buttonLinkReset, controlPaddingBlock, controlSizeFallback, cssBorderRadius, cssBorderWidth, cssColorValue, cssSpacing, cursorDisabled, opacityDisabled, overflowWrapFlexText, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var hoverStyles = function hoverStyles(href) {
  return css(["background-color:", ";color:", ";", ";"], cssColorValue(semanticColors.backgroundElevatedHighlight), cssColorValue(semanticColors.textBase), href && css(["cursor:default;"]));
};
var activeStyles = css(["&,&:hover{background-color:", ";color:", ";}"], cssColorValue(semanticColors.backgroundElevatedPress), cssColorValue(semanticColors.textBase));
var selectedStyles = function selectedStyles($isUsingKeyboard) {
  return css(["", ";padding-inline-end:", ";"], $isUsingKeyboard && /* we only want to apply a background color if the user is selecting via keyboard controls */css(["&,&:hover{background-color:", ";color:", ";}"], cssColorValue(semanticColors.backgroundElevatedPress), cssColorValue(semanticColors.textBase)), "calc(".concat(cssSpacing('tighter', '12px'), " * 2 + ").concat(cssSpacing('base', '12px'), ")"));
};
var dividerStyles = css(["border-block-start:", " solid ", ";border-start-start-radius:0;border-start-end-radius:0;"], cssBorderWidth('hairline'), cssColorValue(semanticColors.decorativeSubdued));
var disabledStyles = css(["&,&:hover{opacity:", ";color:", ";background-color:transparent;cursor:", ";}"], opacityDisabled, cssColorValue(semanticColors.textBase), cursorDisabled);
export var Link = styled( /*#__PURE__*/React.forwardRef(function NavigationItemLink(_ref, ref) {
  var $divider = _ref.$divider,
    $isHover = _ref.$isHover,
    $isActive = _ref.$isActive,
    $useBrowserDefaultFocusStyle = _ref.$useBrowserDefaultFocusStyle,
    $isUsingKeyboard = _ref.$isUsingKeyboard,
    $size = _ref.$size,
    Component = _ref.component,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Link",
  componentId: "sc-qrqq4c-0"
})(["", ";", ";display:flex;align-items:center;position:relative;padding-block:", ";padding-inline:", ";color:", ";text-align:start;text-decoration:none;overflow-wrap:break-word;min-block-size:", ";border-radius:", ";", ";&:hover{", "}&:active{", "}", " ", ";", ";", ";", ";"], rootStyle(), function (props) {
  return props.component === 'button' && css(["", ";inline-size:100%;"], buttonLinkReset(props.$useBrowserDefaultFocusStyle));
}, function (props) {
  return props.$size === 'small' ? cssSpacing('tighter-4', controlPaddingBlock.sm) : cssSpacing('tighter-2', controlPaddingBlock.md);
}, cssSpacing('tighter', '12px'), cssColorValue(semanticColors.textBase), function (props) {
  return props.$size === 'small' ? controlSizeFallback.small : controlSizeFallback.medium;
}, cssBorderRadius('larger'), overflowWrapFlexText(), function (props) {
  return hoverStyles(props.href);
}, activeStyles, function (props) {
  return props.$isHover && hoverStyles(props.href);
}, function (props) {
  return props.$isActive && activeStyles;
}, function (props) {
  return props.selected && selectedStyles(props.$isUsingKeyboard);
}, function (props) {
  return props.disabled && disabledStyles;
}, function (props) {
  return props.$divider && dividerStyles;
});